import { render, staticRenderFns } from "./loginShell.vue?vue&type=template&id=baf9041c&scoped=true"
import script from "./loginShell.vue?vue&type=script&lang=js"
export * from "./loginShell.vue?vue&type=script&lang=js"
import style0 from "./loginShell.vue?vue&type=style&index=0&id=baf9041c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf9041c",
  null
  
)

export default component.exports